module.exports = __webpack_public_path__ + "static/assets/4ef9378078d331db8fa055d21aee5e5b.gif";